<template>
  <div>
    <div class="h-toolbarBg">
      <ejs-toolbar :items="toolbarItems"></ejs-toolbar>
    </div>
    <div class="h100-80 h-scroll">
      <ejs-grid :dataSource="devData" ref="grid">
        <e-columns>
          <e-column type="checkbox" width="50" textAlign="center"></e-column>
          <e-column field="id" :visible="false"></e-column>
          <e-column field="neId" :visible="false"></e-column>
          <e-column field="equipmentName" :headerText="$t('Topo.devName')" width="120" textAlign="Center"></e-column>
          <e-column field="typeName" :headerText="$t('Topo.devType')" width="120" textAlign="Center"></e-column>
          <e-column field="esn" :headerText="$t('Security.Lic.esn')" width="120" textAlign="Center"></e-column>
          <e-column field="displaySoftwareVersion" :headerText="$t('Topo.devSoftVersion')" width="120" textAlign="Center"></e-column>
          <e-column field="uploadStatus" :headerText="$t('Security.Lic.uploadStatus')" width="120" textAlign="Center"  :formatter='uploadStatusFormat'></e-column>
          <e-column field="uploadTime" :headerText="$t('Security.Lic.uploadTime')" width="120" textAlign="Center"  :formatter='uploadDate'></e-column>
          <e-column field="activeStatus" :headerText="$t('Security.Lic.activeStatus')" width="120" textAlign="Center"  :formatter='actStatusFormat'></e-column>
          <e-column field="activeTime" :headerText="$t('Security.Lic.activeTime')" width="120" textAlign="Center"  :formatter='actDate'></e-column>
        </e-columns>
      </ejs-grid>
    </div>
    <CustomDialog ref="upDevLicDialog"
                  v-bind:element="upDevLicDialog.element"
                  v-bind:styles="upDevLicDialog.styles">
      <template slot="dialog-content">
        <ejs-uploader ref="upDevLic" name="upLicense"
                    :asyncSettings="upDevSettings.asyncSettings"
                    :multiple="upDevSettings.multiple"
                    :autoUpload="upDevSettings.autoUpload"
                    :uploading="onFileUpload"
                    :allowedExtensions = "upDevSettings.extensions"
                    :success="uploadResult">
                    </ejs-uploader>
      </template>
    </CustomDialog>
    <CustomDialog ref="licDetailDialog"
                  v-bind:element="licDetailDialog.element"
                  v-bind:styles="licDetailDialog.styles">
      <template slot="dialog-content">
        <LicDetail ref="licDetail"></LicDetail>
      </template>
    </CustomDialog>
  </div>
</template>
<script>
import CustomDialog from '../../common/CustomDialog';
import LicDetail from './licDetail';
import { EventBus } from "../../../plugins/eventBus";
import { resolve } from 'url';

export default {
    name: 'DeviceLicense',
    components: {
      CustomDialog,
      LicDetail
    },
    data() {
      return {
        devData: [],
        toolbarItems: [
          { prefixIcon: 'icon hero-icon hero-icon-refresh', tooltipText: this.$t('Alarm.refresh'), click: this.refreshList },
          { prefixIcon: 'icon hero-icon hero-icon-upload', tooltipText: this.$t('Common.upload'), click: this.showUpload },
          { prefixIcon: 'icon hero-icon hero-icon-confirm', tooltipText: this.$t('Security.active'), click: this.activeLicense },
          { prefixIcon: 'icon hero-icon hero-icon-synchronize',tooltipText: this.$t('Alarm.synchronize'), click: this.syncDevLicense},
          { prefixIcon: 'icon hero-icon hero-icon-details', tooltipText: this.$t('Common.detail'), click: this.showDetail }
        ],
        upDevLicDialog: {
          element: {
            target: '#app',
            isClose: true,
            refName: 'upDevLicDialog',
            buttonGroup: [
              {
                click: this.closeUpload,
                buttonModel: { content: `${this.$t('Common.close')}` }
              }
            ],
            title: `${this.$t('Login.uploadLicense')}`
          },
          styles: {
            width: '600px',
            height: '400px',
            model: true,
            visible: false
          }
        },
        licDetailDialog: {
          element: {
            target: '#app',
            isClose: true,
            refName: 'licDetailDialog',
            buttonGroup: [
              {
                click: this.closeDetail,
                buttonModel: { content: `${this.$t('Common.close')}` }
              }
            ],
            title: `${this.$t('Security.Lic.licenseDetail')}`
          },
          styles: {
            width: '800px',
            height: '500px',
            model: true,
            visible: false
          }
        },
        upDevSettings: {
          asyncSettings: {
            saveUrl: '/lte/ems/license/uploadDeviceLicense',
            removeUrl: ''
          },
          multiple: false,
          autoUpload: false,
          extensions: '.enc'
        },
      }
    },
  methods: {
    actStatusFormat(grids, data) {
      if(data.activeStatus == 1){
         return `${this.$t('Security.Lic.activeStatus_activated')}`;
      }else{
        return `${this.$t('Security.Lic.activeStatus_inactivated')}`;
      }
    },
    uploadStatusFormat(grids, data) {
      if(data.uploadStatus == 1){
         return `${this.$t('Security.Lic.uploadStatus_uploaded')}`;
      }else{
        return `${this.$t('Security.Lic.uploadStatus_unupload')}`;
      }
    },
    actDate(grids, data) {
      if(!!data.activeTime&&data.activeTime!=null){
        return this.formatDateTime(data.activeTime);
      }else{
        return '';
      }
    },
    uploadDate(grids, data) {
        if(!!data.uploadTime&&data.uploadTime!=null){
          return this.formatDateTime(data.uploadTime);
        }else{
          return '';
        }
    },

    formatDateTime(timeStamp) {
        var date = new Date();
        date.setTime(timeStamp);
        var y = date.getFullYear();
        var m = date.getMonth() + 1;
        m = m < 10 ? ('0' + m) : m;
        var d = date.getDate();
        d = d < 10 ? ('0' + d) : d;
        var h = date.getHours();
        h = h < 10 ? ('0' + h) : h;
        var minute = date.getMinutes();
        var second = date.getSeconds();
        minute = minute < 10 ? ('0' + minute) : minute;
        second = second < 10 ? ('0' + second) : second;
        return y + '-' + m + '-' + d+' '+h+':'+minute+':'+second;
    },

    findDevList() {
      let url = '/lte/ems/license/findLicDevList';
      let That = this;
      this.axios.get(url, {}).then(response => {
        let result = response.data;
        That.devData = result;
      });
    },
    checkSelectRecord() {
      let record = this.$refs.grid.getSelectedRecords();
      if (record === null || record === '') {
        this.eventEmit('warning',`${this.$t('Common.tips.noSelect')}`);
        return false;
      }
      if (record.length === 0) {
        this.eventEmit('warning',`${this.$t('Common.tips.selectOne')}`);
        return false;
      }
      if (record.length !== 1) {
        this.eventEmit('warning',`${this.$t('Common.tips.onlyOneSelect')}`);
        return false;
      }
      return true;
    },
    onFileUpload(args) {
      let record = this.$refs.grid.getSelectedRecords();
      args.customFormData = [{'neId': record[0].neId}]
    },
    showUpload() {
      if(this.checkSelectRecord()){
        this.$refs.upDevLicDialog.show();
      }
    },
    showDetail() {
      if(this.checkSelectRecord()){
        let record = this.$refs.grid.getSelectedRecords();
        if(record[0].activeStatus==1) {
          this.$refs.licDetail.findDevLicense(record[0].neId);
          this.$refs.licDetailDialog.show();
        }else {
          this.eventEmit('warning',`${this.$t('Security.Lic.activeLicense')}`);
        }
      }
    },
    closeDetail() {
      this.$refs.licDetailDialog.clear();
      this.$refs.licDetailDialog.close();
    },
    activeLicense() {
      if(this.checkSelectRecord()){
        let record = this.$refs.grid.getSelectedRecords();
        let url = '/lte/ems/license/actDeviceLicense';
        let That = this;
         if(record[0].activeStatus==1 ) {
             this.eventEmit('warning',`${That.$t('Security.Lic.activeLicense_warntip')}`);
         } else if(record[0].uploadStatus!=1){
            this.eventEmit('warning',`${That.$t('Security.Lic.activeLicense_warntip1')}`);
         } else{
          this.$axios.post(url, 'neId='+record[0].neId).then(res => {
            console.log(res);
            if(!!res.data && res.data.success==0){
              That.eventEmit('success',res.data.msg);
              That.findDevList();
            }else{
              That.eventEmit('error',`${That.$t('Common.tips.failure')}`);
            }
          })
        }
      }
    },
    syncDevLicense(){
      if(this.checkSelectRecord()){
        
        let record = this.$refs.grid.getSelectedRecords();

         if(record[0].activeStatus!=1 &&record[0].uploadStatus!=1) {
          let url = '/lte/ems/license/syncDeviceLicense';
          let That = this;
          this.$axios.post(url, 'neId='+record[0].neId).then(res => {

          if(!!res.data && res.data.success==0){
            That.eventEmit('success',res.data.msg);
            That.findDevList();
          }else{
            That.eventEmit('error',`${That.$t('Common.tips.failure')}`);
          }
        })
        }else {
          this.eventEmit('warning',`${That.$t('Security.Lic.syncDevLicense_warntip')}`);
        }
        
      }
    },
    closeUpload() {
      this.$refs.upDevLicDialog.clear();
      this.$refs.upDevLicDialog.close();
    },
    uploadResult(args) {
      let event = args.e;
      let info = event.target.responseText;
      document.getElementsByClassName("e-file-status")[0].innerHTML = info;
      console.log(document.getElementsByClassName("e-file-status e-upload-success")[0].innerHTML);
    },
    refreshList() {
      this.findDevList();
    },
    eventEmit(type, content) {
      EventBus.$emit('toast', {type: type, content: content})
    }
  },
  mounted() {
      this.findDevList();
  }
}
</script>

